import type { RouteLocationNormalizedGeneric } from 'vue-router'

import { useTutorBillingStore } from '@stores/tutor-billing'

import { TUTOR_BILLING_DEFAULT_PER_PAGE } from '@config/tutor-billing'
import { MAX_PER_PAGE, toPaginationValue } from '@helpers/route'
import { queryToFilters } from '@helpers/tutor-billing-query'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const store = useTutorBillingStore()

  store.setFilters(queryToFilters(to.query))
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, TUTOR_BILLING_DEFAULT_PER_PAGE, MAX_PER_PAGE))
})
